import { render, staticRenderFns } from "./Death.vue?vue&type=template&id=7a0ef4a0&scoped=true&"
import script from "./Death.vue?vue&type=script&lang=js&"
export * from "./Death.vue?vue&type=script&lang=js&"
import style0 from "./Death.vue?vue&type=style&index=0&id=7a0ef4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0ef4a0",
  null
  
)

export default component.exports